import * as types from '../constants/actionTypes';

// ── Return Orders ──────────────────────────────────────────────────────────────

export const createReturnOrderRequest = (data) => ({
  type: types.CREATE_RETURN_ORDER_REQUEST,
  payload: data,
});
export const createReturnOrderSuccess = (data) => ({
  type: types.CREATE_RETURN_ORDER_SUCCESS,
  payload: data,
});
export const createReturnOrderFailure = (error) => ({
  type: types.CREATE_RETURN_ORDER_FAILURE,
  payload: error,
});

export const fetchReturnOrdersRequest = (params = {}) => ({
  type: types.FETCH_RETURN_ORDERS_REQUEST,
  payload: params,
});
export const fetchReturnOrdersSuccess = (data) => ({
  type: types.FETCH_RETURN_ORDERS_SUCCESS,
  payload: data,
});
export const fetchReturnOrdersFailure = (error) => ({
  type: types.FETCH_RETURN_ORDERS_FAILURE,
  payload: error,
});

export const fetchReturnOrderRequest = (id) => ({
  type: types.FETCH_RETURN_ORDER_REQUEST,
  payload: id,
});
export const fetchReturnOrderSuccess = (data) => ({
  type: types.FETCH_RETURN_ORDER_SUCCESS,
  payload: data,
});
export const fetchReturnOrderFailure = (error) => ({
  type: types.FETCH_RETURN_ORDER_FAILURE,
  payload: error,
});

export const approveReturnOrderRequest = (id) => ({
  type: types.APPROVE_RETURN_ORDER_REQUEST,
  payload: id,
});
export const approveReturnOrderSuccess = (data) => ({
  type: types.APPROVE_RETURN_ORDER_SUCCESS,
  payload: data,
});
export const approveReturnOrderFailure = (error) => ({
  type: types.APPROVE_RETURN_ORDER_FAILURE,
  payload: error,
});

export const updateReturnOrderStatusRequest = (id, status) => ({
  type: types.UPDATE_RETURN_ORDER_STATUS_REQUEST,
  payload: { id, status },
});
export const updateReturnOrderStatusSuccess = (data) => ({
  type: types.UPDATE_RETURN_ORDER_STATUS_SUCCESS,
  payload: data,
});
export const updateReturnOrderStatusFailure = (error) => ({
  type: types.UPDATE_RETURN_ORDER_STATUS_FAILURE,
  payload: error,
});

// ── Credit Notes ───────────────────────────────────────────────────────────────

export const createCreditNoteRequest = (data) => ({
  type: types.CREATE_CREDIT_NOTE_REQUEST,
  payload: data,
});
export const createCreditNoteSuccess = (data) => ({
  type: types.CREATE_CREDIT_NOTE_SUCCESS,
  payload: data,
});
export const createCreditNoteFailure = (error) => ({
  type: types.CREATE_CREDIT_NOTE_FAILURE,
  payload: error,
});

export const fetchCreditNotesRequest = (params = {}) => ({
  type: types.FETCH_CREDIT_NOTES_REQUEST,
  payload: params,
});
export const fetchCreditNotesSuccess = (data) => ({
  type: types.FETCH_CREDIT_NOTES_SUCCESS,
  payload: data,
});
export const fetchCreditNotesFailure = (error) => ({
  type: types.FETCH_CREDIT_NOTES_FAILURE,
  payload: error,
});

export const fetchCreditNoteRequest = (id) => ({
  type: types.FETCH_CREDIT_NOTE_REQUEST,
  payload: id,
});
export const fetchCreditNoteSuccess = (data) => ({
  type: types.FETCH_CREDIT_NOTE_SUCCESS,
  payload: data,
});
export const fetchCreditNoteFailure = (error) => ({
  type: types.FETCH_CREDIT_NOTE_FAILURE,
  payload: error,
});

export const adjustCreditNoteRequest = (id, billReceiptId) => ({
  type: types.ADJUST_CREDIT_NOTE_REQUEST,
  payload: { id, billReceiptId },
});
export const adjustCreditNoteSuccess = (data) => ({
  type: types.ADJUST_CREDIT_NOTE_SUCCESS,
  payload: data,
});
export const adjustCreditNoteFailure = (error) => ({
  type: types.ADJUST_CREDIT_NOTE_FAILURE,
  payload: error,
});

export const clearReturnError = () => ({
  type: types.CLEAR_RETURN_ERROR,
});
